import React, { Component } from 'react';
import Recipe from '../../../../services/api/Recipe';
import { List, Card, Tag } from 'antd';
import { Link } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroller';
import Search from '../../../../components/Search';

export default class RecipeList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            recipes: [],
            loading: false,
            hasMore: true,
            nextPage: null,
            searchQuery: ''
        };

        this.recipeApi = new Recipe(props);
    }

    componentDidMount() {
        this.fetchRecipes();
    }

    fetchRecipes = () => {
        this.setState({ loading: true });
        this.recipeApi.list(this.state.nextPage)
            .then(res => {
                let nextPage = null;
                let recipes = this.state.recipes;
                recipes = recipes.concat(res.data.data);
                if (res.data._links.nextPage) {
                    nextPage = res.data._links.nextPage.href;
                }
                this.setState({ recipes, nextPage, loading: false });
            })
            .catch(_ => {
                this.recipeApi.retry({ cb: this.fetchRecipes });
            });
    }

    handleInfiniteOnLoad = () => {
        if (this.state.nextPage === null) {
            this.setState({ hasMore: false });
            return;
        }

        this.fetchRecipes();
    }

    search = (query) => {
        this.setState({ loading: true, searchQuery: query });
        this.recipeApi.search(query)
            .then(res => {
                let nextPage = null;
                if (res.data._links.nextPage) {
                    nextPage = res.data._links.nextPage.href;
                }
                this.setState({ recipes: res.data.data, loading: false, nextPage });
            })
            .catch(_ => {
                this.recipeApi.retry({ params: [query], cb: this.search });
            });
    }

    searchByTags = (tags) => {
        this.setState({ loading: true });
        this.recipeApi.searchByTags(tags)
            .then(res => {
                let nextPage = null;
                if (res.data._links.nextPage) {
                    nextPage = res.data._links.nextPage.href;
                }
                this.setState({ recipes: res.data.data, loading: false, nextPage });
            })
            .catch(_ => {
                this.recipeApi.retry({ params: [tags], cb: this.searchByTags });
            });
    }

    clearSearch = () => {
        this.setState({ recipes: [], searchQuery: '' });
        this.fetchRecipes();
    }

    renderItem = (item, index) => {
        const featured = item.images.filter(image => {
            return image.featured === true;
        });

        const image = featured.length > 0 ? featured[0] : item.images[0];

        return (
            <List.Item>
                <Card
                    style={{ minHeight: '336px' }}
                    cover={(
                        <Link to={{
                            pathname: `/recipes/${item.id}`,
                            state: { recipe: item}
                        }}>
                            <img style={{ width: 'inherit', height: '205px', objectFit: 'cover' }} alt="example" src={image.url} />
                        </Link>
                    )}
                >
                    <Link to={{
                            pathname: `/recipes/${item.id}`,
                            state: { recipe: item}
                        }}>
                            <List.Item.Meta
                                title={(
                                    <div style={{ height: '44px' }}>
                                        {item.title.length > 62 ? item.title.slice(0, 63) + '...' : item.title}
                                    </div>
                                )} 
                            />
                    </Link>
                
                    <div style={{marginTop: '10px', maxHeight: '23px', overflow: 'hidden'}}>
                        {item.tags.map(t => (
                            <Tag key={t} color="volcano">{t}</Tag>
                        ))}
                    </div>
                </Card>
            </List.Item>
        );
    }

    render() {
        const { recipes, loading, hasMore, searchQuery } = this.state;
        return (
            <div>
                <div style={{ marginBottom: '40px' }}>
                    <Search
                        placeholder="Sök recept"
                        onSearch={this.search}
                        onTagSearch={this.searchByTags}
                        onClear={this.clearSearch}
                        loading={loading.search}
                        useTags
                    />
                </div>

                <InfiniteScroll
                    initialLoad={false}
                    pageStart={0}
                    loadMore={this.handleInfiniteOnLoad}
                    hasMore={!loading && hasMore}
                    useWindow={true}
                    >
                        <List
                            grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 3 }}
                            loading={loading}
                            dataSource={recipes}
                            renderItem={this.renderItem}
                            locale={{ emptyText: `Inget resultat hittdes för: ${searchQuery}` }}
                        />
                </InfiniteScroll>        
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/recipe/RecipeList.js